import {RichTextEditor, type RichTextEditorFunctionsType} from '@forecast-it/design-system';
import React from 'react';
import {useDraftJsHtmlConversion} from './useDraftJsConversion';
import {RichTextEditorProps} from '@forecast-it/design-system/dist/forecast-v2/components/inputs/richTextEditor/RichTextEditor';

type RichTextEditorDraftJsWrapperProps = RichTextEditorProps & {
	peopleMentions?: {id: string; text: string}[];
	initialDraftJsContent: string;
	onDraftJsChanged?: (string) => void;
	'data-cy'?: string;
	id?: string;
	editorRef?: React.RefObject<RichTextEditorFunctionsType>;
	readOnly?: boolean;
	maxHeight?: string;
	placeholder?: string;
};

export const RichTextEditorDraftJsWrapper = ({
	peopleMentions,
	initialDraftJsContent,
	onDraftJsChanged,
	'data-cy': dataCy,
	id = 'editor',
	editorRef,
	readOnly,
	maxHeight,
	placeholder,
	...rest
}: RichTextEditorDraftJsWrapperProps): React.JSX.Element => {
	const {initialHtml, convertHtmlToDraftJs} = useDraftJsHtmlConversion({
		initialDraftJsContent,
		onDraftJsChanged,
	});
	return (
		<RichTextEditor
			id={id}
			data-cy={dataCy}
			peopleMentions={peopleMentions}
			onBlur={convertHtmlToDraftJs}
			initialHtml={initialHtml}
			ref={editorRef}
			readOnly={readOnly}
			maxHeight={maxHeight}
			placeholder={placeholder}
			{...rest}
		/>
	);
};
